import React, { useEffect } from "react";

import {
    Route,
    BrowserRouter as Router,
    Routes as Switch,
} from "react-router-dom";
// import { GuardedRoute, GuardProvider } from "react-router-guards";

import Recovery from "./auth/components/recovery";


export default function Routes() {

    useEffect(() => {
        document.title = 'Recuperar Senha - EssentialOne'
    }, [])

    return (
        <Router>
            <Switch>
                <Route element={<Recovery />} path="/" exact />
            </Switch>
        </Router>
    )
}

